import UploadFileOutlinedIcon from '@mui/icons-material/UploadFileOutlined';
import { Box, Stack } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import { DEFAULT_ICON_CLASS_NAME } from '../../theme/constants/icon';
import { DASHED_OUTLINE_STACK_CLASS_NAME } from '../../theme/constants/stack';
import DocumentUploadLabel from '../document-upload';
import ClearIconButton from '../icon-buttons/ClearIconButton';

const DocumentFilePicker = ({
  inputId,
  fileName,
  onFileChange,
  onClear,
  sx,
}) => (
  <Stack
    component="label"
    htmlFor={inputId}
    direction="row"
    alignItems="center"
    className={DASHED_OUTLINE_STACK_CLASS_NAME}
    sx={sx}
  >
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: 'gray.A100',
        borderRadius: '50%',
        width: 28,
        height: 28,
        flexShrink: 0,
      }}
    >
      <UploadFileOutlinedIcon
        className={DEFAULT_ICON_CLASS_NAME}
        sx={{ fontSize: 20 }}
      />
    </Box>
    <DocumentUploadLabel fileName={fileName} noWrap truncate />
    {Boolean(fileName) && (
      <ClearIconButton onClick={onClear} sx={{ ml: 0 }} />
    )}
    <input
      style={{ display: 'none' }}
      id={inputId}
      type="file"
      onChange={(event) => onFileChange(event.target.files[0])}
    />
  </Stack>
);

DocumentFilePicker.propTypes = {
  inputId: PropTypes.string.isRequired,
  fileName: PropTypes.string,
  onFileChange: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired,
  sx: PropTypes.shape({}),
};

DocumentFilePicker.defaultProps = {
  fileName: '',
  sx: {},
};

export default DocumentFilePicker;
